import PropTypes from 'prop-types'
import React from 'react'

import Icon from './base/Icon'
import { container, overlay, pushup } from './PollingOverlay.css'

const PollingOverlay = ({ polling, children }) => {
  if (!polling) return children

  return (
    <div className={container}>
      <div className={overlay}>
        <div>
          <Icon name="spinner" color="#3688DF" spin size="50" />
        </div>
        <h3>We&apos;re uploading your paper...</h3>
        <div className={pushup} />
      </div>
      {children}
    </div>
  )
}

PollingOverlay.propTypes = {
  polling: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
}

export default PollingOverlay
